// extracted by mini-css-extract-plugin
module.exports = {"cardsGrid":"TradingContestsOngoingSlider_cardsGrid__EQ8VT","slide":"TradingContestsOngoingSlider_slide__IaCW_","placeholder":"TradingContestsOngoingSlider_placeholder__KAFZ2"};